export default __webpack_public_path__ + "static/media/Detail-POS.f13f208a.png";